import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  name: string;
  city: string;
};
export const firstWave: Testimonial[] = [{
  quote: 'Organicé las viandas de toda la semana en una tarde.',
  name: 'Mariela G.',
  city: 'Córdoba'
}, {
  quote: 'Mi hijo por fin come lo mismo que sus compañeros en los cumpleaños.',
  name: 'Laura P.',
  city: 'Rosario'
}, {
  quote: 'Bajé el gasto en productos sin TACC un 40% desde el primer mes.',
  name: 'Roberto M.',
  city: 'Buenos Aires'
}];
export const secondWave: Testimonial[] = [{
  quote: 'El mapa visual de cocina fue un antes y un después con mi familia.',
  name: 'Cecilia R.',
  city: 'Mendoza'
}, {
  quote: 'Los scripts para el colegio los usé al otro día. La seño me agradeció la claridad.',
  name: 'Pablo A.',
  city: 'Neuquén'
}, {
  quote: 'Ahora tengo el menú de toda la semana listo en 10 minutos.',
  name: 'Valeria M.',
  city: 'Tucumán'
}];
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-166" data-mp="m5kkqkssonau">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-wheat text-wheat" aria-hidden="true" data-id="element-167" data-mp="78tv338xapyf" data-mpi={i} />)}
    </div>;
}
type TestimonialsProps = {
  items: Testimonial[];
  variant?: 'light' | 'dark';
  title?: string;
};
export function Testimonials({
  items,
  variant = 'light',
  title
}: TestimonialsProps) {
  const isDark = variant === 'dark';
  return <section className={`w-full px-5 py-16 sm:px-8 lg:py-20 ${isDark ? 'bg-forest-dark' : 'bg-cream-deep/60'}`} aria-label="Testimonios de clientes" data-id="element-168" data-mp="q7ehihzvd75q">
      <div className="mx-auto max-w-6xl" data-id="element-169" data-mp="1ius87ycz56he">
        {title && <h2 className={`mb-10 text-center font-display text-2xl sm:text-3xl ${isDark ? 'text-cream' : 'text-forest-dark'}`} data-id="element-170" data-mp="1it7fmea7zxm6">
            {title}
          </h2>}
        <ul className="grid gap-5 md:grid-cols-3" data-id="element-171" data-mp="1sj5urglmwt1c">
          {items.map((t, i) => <motion.li key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08,
          ease: 'easeOut'
        }} className={`flex flex-col gap-4 rounded-2xl border p-6 ${isDark ? 'border-cream/12 bg-cream/5' : 'border-forest/10 bg-cream-card shadow-soft'}`} data-id="element-172" data-mp="1sh33yucnqvvk" data-mpi={i}>
              <Stars data-id="element-173" data-mp="10s9stb1448su" />
              <blockquote className={`font-display text-lg leading-snug ${isDark ? 'text-cream' : 'text-forest-dark'}`} data-id="element-174" data-mp="10srq8azigt2c">
                “{t.quote}”
              </blockquote>
              <footer className={`mt-auto text-sm ${isDark ? 'text-cream/60' : 'text-forest-dark/60'}`} data-id="element-175" data-mp="qvwqjori4mmh">
                — {t.name}, {t.city}
              </footer>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}